import { styled } from 'styled-components';

export const Input = styled.input`
  width: 100%;
  align-items: center;
  gap: 10px;
  padding: ${props => (props.$icon ? '12px 12px 12px 48px' : '12px 12px 12px 12px')};
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: none;
  border-bottom: 1px solid #e2dddb;
  &:focus {
    outline: none;
    border-bottom: 1px solid #000;
  }
  &::placeholder {
    color: ${props => (props.$noOpacity ? '#000' : '')};
    opacity: ${props => (props.$noOpacity ? 1 : 0.5)};
  }

  font-size: 16px;
  font-style: normal;
  font-family: 'Poppins-Medium';

  line-height: normal;
  letter-spacing: -0.2px;
  background-color: transparent;
`;

export const TextArea = styled.textarea`
  width: 380px;
  align-items: center;
  gap: 10px;
  padding: ${props => (props.$icon ? '12px 12px 12px 48px' : '12px 12px 12px 12px')};
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: none;
  border-bottom: 1px solid #e2dddb;
  &:focus {
    outline: none;
    border-bottom: 1px solid #000;
  }
  &::placeholder {
    opacity: 0.5;
  }
  color: #000;

  font-size: 16px;
  font-style: normal;
  font-family: 'Poppins-Medium';

  line-height: normal;
  letter-spacing: -0.2px;
`;

export const InputWrapper = styled.div`
  width: 100%;
  display: flex;
  position: relative;
`;

export const Optional = styled.span`
  position: absolute;
  right: 24px;
  top: 14px;

  font-family: 'Poppins-Light';

  font-size: 14px;

  opacity: 0.5;

  letter-spacing: -0.2px;
`;
